
import Vue from "vue";
declare var $: any;
declare var require: any;
import bus from '../service/bus';


export default Vue.extend({
  name: "Home",
  data() {
    return {
      diseaseData: [] as any,
      multipleOmicsData: [
        {
          image: require('@/assets/images/omics1.png'),
          title: "Transcriptome",
          menu: 'single-cell RNA-seq',
          describe: ['scRNA-seq','RNA-seq']
        },
        {
          image: require('@/assets/images/omics2.png'),
          title: 'Genome',
          menu: 'GWAS',
          describe: ['GWAS']
        },
        {
          image: require('@/assets/images/omics3.png'),
          title: 'Immunome',
          menu: 'single-cell TCR-seq',
          describe: ['scTCR-seq','TCR-seq']
        },
        {
          image: require('@/assets/images/omics4.png'),
          title: 'Spatial transcriptome',
          menu: 'spatial transcriptomics',
          describe: ['10x Visium']
        },
        {
          image: require('@/assets/images/omics5.png'),
          title: 'Epigenome',
          menu: 'single-cell ATAC-seq',
          describe: ['scATAC-seq','ATAC-seq']
        },
        {
          image: require('@/assets/images/omics6.png'),
          title: 'Single-cell multimodal',
          menu: 'CITE-seq',
          describe: ['CITE-seq']
        }
      ]
    };
  },
  created() {
    this.setDiseaseData();
  },
  mounted() {
    bus.$on('changLanguage',()=>{
      this.setDiseaseData();
    })
    this.getIPs((ip) => {
      this.saveIp(ip);
});
  },
  methods: {
    saveIp(ip: any){
      if(ip!=null){
        localStorage.setItem("ip", ip);
        // fetch("https://freeapi.ipip.net?ip=183.6.9.113")
        //   .then(response => response.text())
        // .then(data => {
        //   localStorage.setItem("Ip", data);
        //   //console.log(data);
        //   // 在这里处理获取到的数据

        // })
      }

    },
    getIPs(callback: (ip: string) => void): void {
      const ipDups: { [ip: string]: boolean } = {};
      const RTCPeerConnection = (window as any).RTCPeerConnection || (window as any).mozRTCPeerConnection || (window as any).webkitRTCPeerConnection;
      const useWebKit = !!((window as any).webkitRTCPeerConnection);
      const mediaConstraints = { optional: [{ RtpDataChannels: true }] };

      const servers = {
        iceServers: [
          { urls: 'stun:stun.services.mozilla.com' },
          { urls: 'stun:stun.l.google.com:19302' },
        ],
      };

      const pc = new RTCPeerConnection(servers, mediaConstraints);

      function handleCandidate(candidate: string): void {
        const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
        const hasIp = ipRegex.exec(candidate);

        if (hasIp) {
          const ipAddr = ipRegex.exec(candidate)![1];
          if (ipDups[ipAddr] === undefined) callback(ipAddr);
          ipDups[ipAddr] = true;
        }
      }

      pc.onicecandidate = function (ice: { candidate: { candidate: string } }): void {
        if (ice.candidate) {
          handleCandidate(ice.candidate.candidate);
        }
      };

      pc.createDataChannel('');

      pc.createOffer(
        function (result: { sdp: string }) {
          pc.setLocalDescription(result, function () {}, function () {});
        },
        function () {}
      );

      setTimeout(function () {
        const lines = pc.localDescription.sdp.split('\n');
        lines.forEach(function (line: string) {
          if (line.indexOf('a=candidate:') === 0) handleCandidate(line);
        });
      }, 1000);
    },
    setDiseaseData(){
      this.diseaseData = [
        {
          label: "respiratorySystemCancer",
          value: "Respiratory system cancer",
          isHover: false,
          children: [
          {
              label: this.$t("lungCancer"),
              value: "Lung cancer",
              children: [
                {
                  label: this.$t("smallCell"),
                  value: "Small cell lung cancer",
                  children: []
                },
                {
                  label: this.$t("Non-smallLung"),
                  value: "Non-small cell lung cancer",
                  children: [
                    {
                      label: this.$t("Non-smallCell"),
                      value: "Non-small cell squamous lung carcinoma",
                      children: []
                    },
                    {
                      label: this.$t("Non-smallAdenocarcinoma"),
                      value: "Non-small cell lung adenocarcinoma",
                      children: []
                    },
                  ]
                }
              ],
            }
          ]
        },
        {
          label: "lowerRespiratoryIllnessess",
          value: "Lower respiratory tract disease",
          isHover: false,
          children: [
            {
                label: this.$t("bronchialDisease"),
                value: "Bronchial disease",
                children: [
                    {
                      label: this.$t("asthma"),
                      value: "Asthma",
                      children: []
                    }
                  ]
              },
              {
                  label: this.$t("lungDisease"),
                  value: "Lung disease",
                  children: [
                      {
                        label: this.$t("interstitialLungDisease"),
                        value: "Interstitial lung disease",
                        children: [
                          {
                            label: this.$t("pulmonaryFibrosis"),
                            value: "Pulmonary fibrosis",
                            children: [
                              {
                                label: this.$t("ipf"),
                                value: "Idiopathic pulmonary fibrosis",
                                children: []
                              }
                            ]
                          },
                          {
                            label: this.$t("extrinsicAllergicAlveolitis"),
                            value: "Extrinsic allergic alveolitis",
                            children: []
                          }
                        ]
                      },
                      {
                        label: this.$t("chronicObstructivePneumonia"),
                        value: "Chronic obstructive pulmonary disease",
                        children: []
                      }
                  ]
              },
              {
                label: this.$t("cysticFibrosis"),
                value: "Cystic fibrosis",
                children: []
              }
          ]
        },
        {
          label: "respiratoryInfectiousDisease",
          value: "Respiratory tract infectious disease",
          isHover: false,
          children: [
            {
              label: this.$t("viralRespiratory"),
              value: "Viral respiratory tract infection",
              children: [
                {
                  label: this.$t("grippe"),
                  value: "Influenza",
                  children: []
                },
                {
                  label: this.$t("COVID19"),
                  value: "COVID-19",
                  children: []
                },
                {
                  label: this.$t("cytomegalovirusInfection"),
                  value: "Cytomegalovirus infection",
                  children: []
                }
              ]
            },
            {
              label: this.$t("bacterialPneumonia"),
              value: "Bacterial pneumonia",
              children: [
                {
                  label: this.$t("klebsiellaPneumonia"),
                  value: "Klebsiella pneumonia",
                  children: []
                },
                {
                  label: this.$t("ventilatorAssociatedPneumonia"),
                  value: "Ventilator associated pneumonia",
                  children: []
                }
              ]
            },
            {
              label: this.$t("tuberculosis"),
              value: "Tuberculosis",
              children: []
            }
          ]
        },
        {
          label: "other",
          value: "Other",
          isHover: false,
          children: [
            {
              label: this.$t("senility"),
              value: "Aging",
              children: []
            },
            {
              label: this.$t("smoke"),
              value: "Smoke exposure",
              children: []
            }
          ]
        }
      ]
    },
    enter(index:number){
      for(let i=0;i<this.diseaseData.length;i++){
        if(i === index){
          this.diseaseData[i].isHover = true;
        }else{
          this.diseaseData[i].isHover = false;
        }
      }
    },
    leave(){
      for(let i=0;i<this.diseaseData.length;i++){
        this.diseaseData[i].isHover = false;
      }
    },
    handleNodeClick(data:any) {
      this.$router.push({path: '/Browse?search=' + data.value});
    }
  },
});
